import styled from 'styled-components';

export const TabContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
